module.exports = __webpack_public_path__ + "img/NotebookAstronaut.13b1800b.svg";